import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Breadcrumbs,
    Link as MLink,
    Tabs,
    Tab,
    Container,
} from "@mui/material";

import { Link } from "react-router-dom";
import '../../App.css';
import { axiosInstance } from "../../Api/Axios/axios";
import { endpoints } from "../../Api/EndPoints/endpoints";

const leftMenu = [
    "GROUP PROFILE",
    "COMPANY PROFILE",
    "VISION & MISSION",
    "MANAGEMENT TEAM",
    "ROC COMPLIANCE ANNUAL RETURN",
    "CERTIFICATES",
    "AWARDS AND RECOGNITIONS",
    "RESEARCH AND DEVELOPMENT",
    "QUALITY POLICY",
    "CLIENTELE",
];

const ManagementTeam = () => {

    const [tabIndex, setTabIndex] = useState(0);
    const [managementData, setManagementData] = useState([]);
    const [categories, setCategories] = useState([]);
     const [rocPdf, setRocPdf] = useState("");

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const fetchManagementData = async () => {
        try {
            const res = await axiosInstance.get(endpoints.AboutUs.ManagmentTeamData);
            const data = res?.data?.data || [];

            const anualpdfRes = await axiosInstance.get(endpoints.AboutUs.anualRetuns)

            // ROC Annual Return PDF
            const rocPdfUrl = anualpdfRes?.data?.data?.[0]?.roc_pdf || "";
            setRocPdf(rocPdfUrl);

            const formattedData = data.map(item => ({
                ...item,
                category: item.category || "Others"
            }));

            setManagementData(formattedData);

            // Get unique categories
            const uniqueCategories = [
                ...new Set(formattedData.map(item => item.category))
            ];

            // 🔥 Force Order:
            // Director → Leadership → Others
            const sortedCategories = [
                ...uniqueCategories.filter(cat =>
                    cat.toLowerCase().includes("director")
                ),
                ...uniqueCategories.filter(cat =>
                    cat.toLowerCase().includes("leadership")
                ),
                ...uniqueCategories.filter(cat =>
                    !cat.toLowerCase().includes("director") &&
                    !cat.toLowerCase().includes("leadership")
                )
            ];

            setCategories(sortedCategories);

            // Ensure default tab is Director if exists
            const directorIndex = sortedCategories.findIndex(cat =>
                cat.toLowerCase().includes("director")
            );

            if (directorIndex !== -1) {
                setTabIndex(directorIndex);
            }

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchManagementData();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const filteredData = managementData.filter(
        item => item.category === categories[tabIndex]
    );

    return (
        <Box sx={{ padding: { xs: 2, md: 4 }, mt: "100px" }}>
            <Container maxWidth="xl">

                {/* Breadcrumb */}
                <Breadcrumbs sx={{ mb: 2, fontSize: "15px" }}>
                    <MLink component={Link} to="/home" underline="hover" color="inherit">
                        Home
                    </MLink>
                    <Typography sx={{ fontSize: "15px" }}>About Us</Typography>
                    <Typography color="text.primary" sx={{ fontSize: "15px" }}>
                        Management Team
                    </Typography>
                </Breadcrumbs>

                <Grid container spacing={3}>

                    {/* Sidebar */}
                    <Grid item size={{ xs: 12, md: 3 }} sx={{ mt: 2 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "15px",
                                mb: 2,
                                textTransform: "uppercase",
                                fontFamily: "Roboto"
                            }}
                        >
                            Product & Services
                        </Typography>

                        <List sx={{ border: "1px solid #ddd" }}>
                            {leftMenu.map((item) => {
                                const isActive = item === "MANAGEMENT TEAM";

                                if (item === "ROC COMPLIANCE ANNUAL RETURN") {
                                    return (
                                        <ListItemButton
                                            key={item}
                                            component="a"
                                            href={rocPdf || "#"}
                                            target={rocPdf ? "_blank" : undefined}
                                            rel={rocPdf ? "noopener noreferrer" : undefined}
                                            disabled={!rocPdf}
                                            sx={{
                                                borderBottom: "1px solid #eee",
                                                backgroundColor: "transparent",
                                                color: "#000",
                                                "&:hover": {
                                                    backgroundColor: "#f5f5f5"
                                                },
                                                fontFamily: "Roboto",
                                                opacity: rocPdf ? 1 : 0.6,
                                                cursor: rocPdf ? "pointer" : "not-allowed"
                                            }}
                                        >
                                            <ListItemText
                                                primary={item}
                                                primaryTypographyProps={{
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    fontFamily: "Roboto"
                                                }}
                                            />
                                        </ListItemButton>
                                    );
                                }

                                return (
                                    <ListItemButton
                                        key={item}
                                        component={Link}
                                        to={`/about/${item.toLowerCase().replace(/ /g, "-")}`}
                                        sx={{
                                            borderBottom: "1px solid #eee",
                                            background: isActive
                                                ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                : "transparent",
                                            color: isActive ? "#fff" : "#000",

                                            "&:hover": {
                                                background: isActive
                                                    ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                    : "#f5f5f5",
                                            },

                                            fontFamily: "Roboto",
                                        }}
                                    >
                                        <ListItemText
                                            primary={item}
                                            primaryTypographyProps={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                fontFamily: "Roboto"
                                            }}
                                        />
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    </Grid>

                    {/* Right Section */}
                    <Grid item size={{ xs: 12, md: 9 }} sx={{ mt: 5 }}>

                        {/* Tabs */}
                        {categories.length > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                                <Box sx={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '12px',
                                    padding: '6px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                }}>
                                    <Tabs
                                        value={tabIndex}
                                        onChange={handleTabChange}
                                        textColor="inherit"
                                        sx={{
                                            minHeight: "auto",
                                            '& .MuiTabs-indicator': {
                                                height: '100%',
                                                borderRadius: '10px',
                                                backgroundColor: '#1BAA63',
                                                zIndex: 0,
                                            }
                                        }}
                                    >
                                        {categories.map((cat, index) => (
                                            <Tab
                                                key={index}
                                                label={cat}
                                                sx={{
                                                    position: 'relative',
                                                    zIndex: 1,
                                                    textTransform: 'capitalize',
                                                    fontWeight: 600,
                                                    fontSize: '16px',
                                                    padding: '12px 28px',
                                                    borderRadius: '10px',
                                                    color: '#000',
                                                    minHeight: 'auto',
                                                    '&.Mui-selected': {
                                                        color: '#fff !important'
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Tabs>
                                </Box>
                            </Box>
                        )}

                        {/* Profile Cards */}
                        {/* {filteredData.map((member, index) => (
                            <Box
                                key={member.id}
                                sx={{
                                    mt: 4,
                                    boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                                    borderRadius: "12px",
                                    p: 3,
                                    background: "#fff"
                                }}
                            >
                                <Grid container spacing={2}>

                                  
                                    {index % 2 === 0 && (
                                        <Grid item size={{ xs: 12, md: 4 }}>
                                            <img
                                                src={member.profile_pic || "/no-image.png"}
                                                alt={member.name || "Management member"}
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "8px"
                                                }}
                                            />
                                        </Grid>
                                    )}

                                   
                                    <Grid item size={{ xs: 12, md: 8 }} sx={{ bgcolor: "#B5BEB2" }}>
                                        <Box
                                            sx={{ padding: "20px" }}
                                            dangerouslySetInnerHTML={{
                                                __html: member.profile_desc || ""
                                            }}
                                        />

                                        <Box sx={{
                                            background: 'linear-gradient(90deg, #1BAA63 0%, #276f9e 100%)',
                                            padding: "15px 20px",
                                            color: "#fff"
                                        }}>
                                            <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                                                {member.name}
                                            </Typography>

                                            <Typography sx={{ fontSize: "14px" }}>
                                                {member.designation}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                 
                                    {index % 2 !== 0 && (
                                        <Grid item size={{ xs: 12, md: 4 }}>
                                            <img
                                                src={member.profile_pic || "/no-image.png"}
                                                alt={member.name || "Management member"}
                                                style={{
                                                    width: "100%",
                                                    borderRadius: "8px"
                                                }}
                                            />
                                        </Grid>
                                    )}

                                </Grid>
                            </Box>
                        ))} */}

                        {/* Profile Cards */}
                        {filteredData.map((member, index) => (
                            <Box
                                key={member.id}
                                sx={{
                                    mt: 4,
                                    boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                                    borderRadius: "12px",
                                    p: { xs: 1, md: 3 },
                                    background: "#fff"
                                }}
                            >


                                {/* ===================== DESKTOP ONLY ===================== */}
                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <Grid
                                        container
                                        spacing={2}
                                        alignItems="start"
                                    >

                                        {index % 2 === 0 ? (
                                            <>
                                                {/* ================= IMAGE LEFT ================= */}
                                                <Grid
                                                    item
                                                    size={{ md: 4 }}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            height: "180px",
                                                            overflow: "hidden",
                                                            borderRadius: "10px",
                                                            backgroundColor: "#f5f5f5",
                                                        }}
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={member.profile_pic || "/no-image.png"}
                                                            alt={member.name || "Management member"}
                                                            sx={{
                                                                width: "100%",
                                                                height: "100%",
                                                                display: "block",
                                                                objectFit: "cover",
                                                                objectPosition: "center",
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                {/* ================= DESCRIPTION RIGHT ================= */}
                                                <Grid
                                                    item
                                                    size={{ md: 8 }}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            backgroundColor: "#B5BEB2",
                                                            p: 2.5,
                                                            borderTopLeftRadius: "10px",
                                                            borderTopRightRadius: "10px",

                                                            "& p": {
                                                                margin: "0 0 10px 0",
                                                                lineHeight: 1.5,
                                                            },

                                                            "& p:last-child": {
                                                                marginBottom: 0,
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: member.profile_desc || "",
                                                        }}
                                                    />

                                                    <Box
                                                        sx={{
                                                            background:
                                                                "linear-gradient(90deg, #1BAA63 0%, #276f9e 100%)",
                                                            p: 1.5,
                                                            color: "#fff",
                                                            borderBottomLeftRadius: "10px",
                                                            borderBottomRightRadius: "10px",
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: "18px",
                                                                fontWeight: 600,
                                                                lineHeight: 1.3,
                                                            }}
                                                        >
                                                            {member.name}
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontSize: "13px",
                                                                lineHeight: 1.4,
                                                            }}
                                                        >
                                                            {member.designation}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </>
                                        ) : (
                                            <>
                                                {/* ================= DESCRIPTION LEFT ================= */}
                                                <Grid
                                                    item
                                                    size={{ md: 8 }}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            backgroundColor: "#B5BEB2",
                                                            p: 2.5,
                                                            borderTopLeftRadius: "10px",
                                                            borderTopRightRadius: "10px",

                                                            "& p": {
                                                                margin: "0 0 10px 0",
                                                                lineHeight: 1.5,
                                                            },

                                                            "& p:last-child": {
                                                                marginBottom: 0,
                                                            },
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: member.profile_desc || "",
                                                        }}
                                                    />

                                                    <Box
                                                        sx={{
                                                            background:
                                                                "linear-gradient(90deg, #1BAA63 0%, #276f9e 100%)",
                                                            p: 1.5,
                                                            color: "#fff",
                                                            borderBottomLeftRadius: "10px",
                                                            borderBottomRightRadius: "10px",
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize: "18px",
                                                                fontWeight: 600,
                                                                lineHeight: 1.3,
                                                            }}
                                                        >
                                                            {member.name}
                                                        </Typography>

                                                        <Typography
                                                            sx={{
                                                                fontSize: "13px",
                                                                lineHeight: 1.4,
                                                            }}
                                                        >
                                                            {member.designation}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                {/* ================= IMAGE RIGHT ================= */}
                                                <Grid
                                                    item
                                                    size={{ md: 4 }}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            height: "180px",
                                                            overflow: "hidden",
                                                            borderRadius: "10px",
                                                            backgroundColor: "#f5f5f5",
                                                        }}
                                                    >
                                                        <Box
                                                            component="img"
                                                            src={member.profile_pic || "/no-image.png"}
                                                            alt={member.name || "Management member"}
                                                            sx={{
                                                                width: "100%",
                                                                height: "100%",
                                                                display: "block",
                                                                objectFit: "cover",
                                                                objectPosition: "center",
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </>
                                        )}

                                    </Grid>
                                </Box>

                                {/* ===================== TAB + MOBILE ONLY ===================== */}
                                <Box sx={{ display: { xs: "block", md: "none" } }}>

                                    {/* Image Top */}
                                    <img
                                        src={member.profile_pic || "/no-image.png"}
                                        alt={member.name}
                                        style={{ width: "100%", borderRadius: "8px" }}
                                    />

                                    {/* Description */}
                                    <Box
                                        sx={{
                                            padding: "20px",
                                            backgroundColor: "#B5BEB2",
                                            mt: 2
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: member.profile_desc || ""
                                        }}
                                    />

                                    {/* Name + Designation */}
                                    <Box
                                        sx={{
                                            background:
                                                "linear-gradient(90deg, #1BAA63 0%, #276f9e 100%)",
                                            padding: "15px 20px",
                                            color: "#fff"
                                        }}
                                    >
                                        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                                            {member.name}
                                        </Typography>

                                        <Typography sx={{ fontSize: "14px" }}>
                                            {member.designation}
                                        </Typography>
                                    </Box>

                                </Box>

                            </Box>
                        ))}

                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default ManagementTeam;